// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/fonts/DMSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/fonts/DMSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/fonts/archia-regular-webfont.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: DMSans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: DMSans;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: Archia;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.Button_button__JBBzO {
  border: none;
  margin: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  border-radius: 999px;
  border: 1px solid;
  width: max-content;
  font-size: 16px;
}

.Button_normal__BrbVd {
  height: 40px;
  padding: 8px 24px;
}

.Button_medium__Usyuv {
  height: 48px;
  padding: 0 32px;
}

.Button_large__cizxk {
  height: 64px;
  padding: 16px 32px;
}
@media (max-width: 1024px) {
  .Button_large__cizxk {
    height: 56px;
  }
}

.Button_primary__9MLUH {
  color: #272E35;
  background-color: #FFFFFF;
  border-color: #272E35;
}

.Button_secondary__sUGsj {
  color: #FFFFFF;
  background-color: #0EB77A;
  border-color: #0EB77A;
}

.Button_tertiary__ioTKC {
  color: #FFFFFF;
  background-color: transparent;
  border-color: #FFFFFF;
}

.Button_quaternary__yHA86 {
  color: #272E35;
  background-color: transparent;
  border-color: #272E35;
}

.Button_primaryAPP__gsOyU {
  background-color: #1D7C4D;
  color: #FFFFFF;
}

@media (max-width: 1024px) {
  .Button_fullWidth__xiCcj {
    width: 100%;
    box-sizing: border-box;
  }
}

@media (min-width: 1025px) {
  .Button_fullWidthDesktop__-XLOo {
    width: 100%;
    box-sizing: border-box;
  }
}

[aria-disabled=true] {
  cursor: not-allowed;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/styles/fonts.scss","webpack://./src/components/Button/Button.module.scss","webpack://./src/styles/globals.scss","webpack://./src/styles/responsive.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,4CAAA;ACCJ;ADEA;EACI,mBAAA;EACA,4CAAA;ACAJ;ADGA;EACI,mBAAA;EACA,4CAAA;ACDJ;AANA;ECMI,YAAA;EACA,SAAA;EACA,UAAA;EAOA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EDfA,eAAA;EACA,4BAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AAaJ;;AAVA;EACI,YAAA;EACA,iBAAA;AAaJ;;AAVA;EACI,YAAA;EACA,eAAA;AAaJ;;AAVA;EACI,YAAA;EACA,kBAAA;AAaJ;AEvCQ;EFwBR;IAIQ,YAAA;EAeN;AACF;;AAZA;EAEI,cGlCM;EHmCN,yBGrCI;EHsCJ,qBGpCM;AHmDV;;AAZA;EAEI,cG3CI;EH4CJ,yBGlCK;EHmCL,qBGnCK;AHkDT;;AAZA;EAEI,cGlDI;EHmDJ,6BAAA;EACA,qBGpDI;AHmER;;AAZA;EAEI,cGvDM;EHwDN,6BAAA;EACA,qBGzDM;AHwEV;;AAZA;EAEI,yBGhDS;EHiDT,cGjEI;AHgFR;;AE9EQ;EFkER;IAEQ,WAAA;IACA,sBAAA;EAeN;AACF;;AE/EQ;EFmER;IAEQ,WAAA;IACA,sBAAA;EAeN;AACF;;AAZA;EACI,mBAAA;EACA,YAAA;AAeJ","sourcesContent":["@font-face {\n    font-family: DMSans;\n    src: URL(../../public/fonts/DMSans-Regular.ttf);\n}\n\n@font-face {\n    font-family: DMSans;\n    src: URL(../../public/fonts/DMSans-Medium.ttf);\n}\n\n@font-face {\n    font-family: Archia;\n    src: URL(../../public/fonts/archia-regular-webfont.ttf);\n}","@use '../../styles/globals' as global; \n@use '../../styles/responsive' as rwd; \n@use '../../styles/colors' as colors; \n@import '../../styles/fonts.scss';\n\n.button {\n    @include global.button;\n\n    cursor: pointer;\n    transition: 0.3s ease-in-out;\n    border-radius: 999px;\n    border: 1px solid;\n    width: max-content;\n    font-size: 16px;\n}\n\n.normal {\n    height: 40px;\n    padding: 8px 24px;\n}\n\n.medium {\n    height: 48px;\n    padding: 0 32px;\n}\n\n.large {\n    height: 64px;\n    padding: 16px 32px;\n    @include rwd.breakpoint(small) {\n        height: 56px;\n    }\n}\n\n.primary {\n    composes: button;\n    color: colors.$primary;\n    background-color: colors.$white;\n    border-color: colors.$primary;\n}\n\n.secondary {\n    composes: button;\n    color: colors.$white;\n    background-color: colors.$green0;\n    border-color: colors.$green0;\n}\n\n.tertiary {\n    composes: button;\n    color: colors.$white;\n    background-color: transparent;\n    border-color: colors.$white;\n}\n\n.quaternary {\n    composes: button;\n    color: colors.$primary;\n    background-color: transparent;\n    border-color: colors.$primary;\n}\n\n.primaryAPP {\n    composes: button;\n    background-color: colors.$primaryAPP;\n    color: colors.$white;\n}\n\n.fullWidth {\n    @include rwd.breakpoint(small) {\n        width: 100%;\n        box-sizing: border-box;\n    }\n}\n\n.fullWidthDesktop {\n    @include rwd.breakpoint(large) {\n        width: 100%;\n        box-sizing: border-box;\n    }\n}\n\n[aria-disabled=\"true\"] {\n    cursor: not-allowed;\n    opacity: 0.5;\n  }","$page-width: 768px;\n$page-width-medium: 1440px;\n$page-width-large: 1440px;\n\n@mixin list-reset {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n}\n\n@mixin button-reset {\n    border: none;\n    margin: 0;\n    padding: 0;\n}\n\n\n@mixin button() {\n    @include button-reset;\n\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n}","@mixin breakpoint($point) {\n    @if $point == small {\n        @media (max-width:  1024px) { @content; }\n    }\n    // @else if $point == medium {\n    //     @media (min-width:  769px) and (max-width: 1280px) { @content; }\n    // }\n    @else if $point == large {\n        @media (min-width:  1025px) { @content; }\n    }\n}","$white: #FFFFFF;\n\n$primary: #272E35;\n\n$grey4: #DEE3E7;\n$secondary: #555F6D;\n$whitealfa: #9E9E9E;\n$emerald5: #F4EAD7;\n$emerald7: #F8F6F1;\n\n$green0: #0EB77A;\n$green4: #08200D;\n$green5: #E1F9F0;\n\n// APP\n$secondaryAPP: #D8F8E7;\n$primaryAPP: #1D7C4D;\n$primaryGreenAPP: #086E49;\n$action: #CFD6DD;\n$surface: #FCFCFD;\n$neutral: #F5F7F9;\n$raspberry: #FBD5E2;\n$greenAPP: #C6F1DA;\n$defaultAPP: #EAEDF0;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__JBBzO`,
	"normal": `Button_normal__BrbVd`,
	"medium": `Button_medium__Usyuv`,
	"large": `Button_large__cizxk`,
	"primary": `Button_primary__9MLUH Button_button__JBBzO`,
	"secondary": `Button_secondary__sUGsj Button_button__JBBzO`,
	"tertiary": `Button_tertiary__ioTKC Button_button__JBBzO`,
	"quaternary": `Button_quaternary__yHA86 Button_button__JBBzO`,
	"primaryAPP": `Button_primaryAPP__gsOyU Button_button__JBBzO`,
	"fullWidth": `Button_fullWidth__xiCcj`,
	"fullWidthDesktop": `Button_fullWidthDesktop__-XLOo`
};
export default ___CSS_LOADER_EXPORT___;
